import '../styles/Services.css';

function Services() {
  return (
    <div className="container py-5">
      <h1 className="text-center mb-5 fw-bold">Professional Services & Expertise</h1>
      <div className="row g-4">
        <div className="col-md-6">
          <div className="card h-100 shadow-sm hover-card">
            <div className="card-body p-4">
              <div className="d-flex align-items-center mb-3">
                <i className="bi bi-code-square fs-2 text-primary me-3"></i>
                <h3 className="card-title mb-0">Software Development</h3>
              </div>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <i className="bi bi-check2-circle text-success me-2"></i>
                  Expert in Java, C#, Python, and Dart development
                </li>
                <li className="mb-2">
                  <i className="bi bi-check2-circle text-success me-2"></i>
                  Full-stack development with Spring Boot, .NET, and Django
                </li>
                <li>
                  <i className="bi bi-check2-circle text-success me-2"></i>
                  Mobile app development using Flutter framework
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card h-100 shadow-sm hover-card">
            <div className="card-body p-4">
              <div className="d-flex align-items-center mb-3">
                <i className="bi bi-hdd-rack fs-2 text-primary me-3"></i>
                <h3 className="card-title mb-0">Infrastructure & DevOps</h3>
              </div>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <i className="bi bi-check2-circle text-success me-2"></i>
                  Windows & Linux server administration and optimization
                </li>
                <li className="mb-2">
                  <i className="bi bi-check2-circle text-success me-2"></i>
                  Cloud infrastructure design and implementation
                </li>
                <li>
                  <i className="bi bi-check2-circle text-success me-2"></i>
                  CI/CD pipeline setup and maintenance
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card h-100 shadow-sm hover-card">
            <div className="card-body p-4">
              <div className="d-flex align-items-center mb-3">
                <i className="bi bi-database fs-2 text-primary me-3"></i>
                <h3 className="card-title mb-0">Database Solutions</h3>
              </div>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <i className="bi bi-check2-circle text-success me-2"></i>
                  Database design and optimization for MSSQL and PostgreSQL
                </li>
                <li className="mb-2">
                  <i className="bi bi-check2-circle text-success me-2"></i>
                  Data migration and integration services
                </li>
                <li>
                  <i className="bi bi-check2-circle text-success me-2"></i>
                  Performance tuning and maintenance
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card h-100 shadow-sm hover-card">
            <div className="card-body p-4">
              <div className="d-flex align-items-center mb-3">
                <i className="bi bi-shield-check fs-2 text-primary me-3"></i>
                <h3 className="card-title mb-0">Cybersecurity</h3>
              </div>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <i className="bi bi-check2-circle text-success me-2"></i>
                  Security assessment and vulnerability testing
                </li>
                <li className="mb-2">
                  <i className="bi bi-check2-circle text-success me-2"></i>
                  Implementation of security best practices and protocols
                </li>
                <li>
                  <i className="bi bi-check2-circle text-success me-2"></i>
                  24/7 monitoring and incident response
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Services; 